import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import DueToday from '../../common/MiniCart/redesign/desktopCart/dueToday';
import { checkIsMidnight, isJointTransactionFlow } from '../../common/Helpers';

const MCartDueToday = (props) => {
  useEffect(() => {
    const { cartData, getCartDataFromApi, updateShowCart } = props;
    if (checkIsMidnight() && !isJointTransactionFlow()) {
      updateShowCart(true);
    }
    if (cartData?.cartDetailsJson?.dueTodayList?.length <= 0) {
      getCartDataFromApi();
    }
  }, []);

  return <DueToday {...props} showCartStatus={(iscartVisibleVal) => props.showCart(iscartVisibleVal)} />;
};

export default MCartDueToday;

MCartDueToday.propTypes = {
  getCartDataFromApi: PropTypes.func,
  dueTodayList: PropTypes.array,
  showCart: PropTypes.func,
  cartData: PropTypes.object,
  updateShowCart: PropTypes.func,
};
